import React from 'react';
import { Grid, Card, CardContent, Typography, CardMedia, Box, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme, isSelected }) => ({
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  },
  backgroundColor: isSelected ? theme.palette.primary.light : 'white',
  '& .MuiCardContent-root': {
    padding: theme.spacing(2),
  },
}));

const StyledCardMedia = styled(CardMedia)({
  height: 180,
  objectFit: 'cover',
});

const CategorySection = ({ categories, selectedCategory, setSelectedCategory }) => {
  return (
    <Box sx={{ py: 4, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold', color: 'text.primary' }}>
          Categories
        </Typography>
        {categories.length === 0 ? (
          <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
            No categories available for the current branch
          </Typography>
        ) : (
          <Grid container spacing={3}>
            {categories.map((category, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <StyledCard
                  onClick={() => setSelectedCategory(category._id)}
                  isSelected={category._id === selectedCategory}
                >
                  <StyledCardMedia
                    component="img"
                    alt={category.Name}
                    image={category.Image}
                    title={category.Name}
                  />
                  <CardContent>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'medium', textAlign: 'center' }}>
                      {category.Name}
                    </Typography>
                  </CardContent>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default CategorySection;